﻿'use strict';

import { toast } from "../utils/toast";

export const notificationHub = (function () {
    var hub = $.connection.notificationHub;


    $.connection.hub.start().done(function (response) {
        console.log('hub activated');
    });

    hub.client.notify = function (response) {
        for (const note of response) {
            if (!localStorage.getItem(`note_${note.ID}`)) {
                localStorage.setItem(`note_${note.ID}`, 'accepted')
                toast(note.Title, note.Description, note.ID);
                hub.server.confirmRead(note.ID);
            }
        }
    };
    hub.client.connectionEstablished = function (response) {
        console.info(`Connection established:${response}`);
    };
    hub.client.connectionRejected = function (response) {
        console.error(`Connection rejected:${response}`);
    };

    return this;
})();